'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState } from 'react';
import { ModalAlert } from '~/components/ui/modal-alert';
const AlertContext = createContext(undefined);
export const AlertProvider = t0 => {
  const $ = _c(23);
  const {
    children
  } = t0;
  const [modalVisible, setModalVisible] = useState(false);
  const [modalOptions, setModalOptions] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = options => {
      setModalOptions(options);
      setModalVisible(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const showAlert = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (title, message, onClick) => {
      showAlert({
        title,
        message,
        buttons: [{
          text: "OK",
          onClick
        }]
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showSuccessAlert = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (title_0, message_0, onClick_0) => {
      showAlert({
        title: title_0,
        message: message_0,
        buttons: [{
          text: "OK",
          onClick: onClick_0,
          style: "destructive"
        }]
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const showErrorAlert = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (title_1, message_1, onConfirm, onCancel) => {
      showAlert({
        title: title_1,
        message: message_1,
        buttons: [{
          text: "Cancel",
          onClick: onCancel,
          style: "cancel"
        }, {
          text: "OK",
          onClick: onConfirm
        }]
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const showConfirmAlert = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (title_2, message_2) => {
      showAlert({
        title: title_2,
        message: message_2,
        loading: true,
        buttons: []
      });
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const showLoadingAlert = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setModalVisible(false);
      setModalOptions(null);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const hideAlert = t6;
  let t7;
  if ($[6] !== modalOptions) {
    t7 = loading => {
      if (modalOptions) {
        setModalOptions({
          ...modalOptions,
          loading
        });
      }
    };
    $[6] = modalOptions;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const setAlertLoading = t7;
  let t8;
  if ($[8] !== modalOptions) {
    t8 = (buttonIndex, loading_0) => {
      if (modalOptions && modalOptions.buttons && modalOptions.buttons[buttonIndex]) {
        const updatedButtons = [...modalOptions.buttons];
        updatedButtons[buttonIndex] = {
          ...updatedButtons[buttonIndex],
          loading: loading_0
        };
        setModalOptions({
          ...modalOptions,
          buttons: updatedButtons
        });
      }
    };
    $[8] = modalOptions;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const setButtonLoading = t8;
  let t9;
  if ($[10] !== modalOptions?.loading) {
    t9 = () => {
      if (!modalOptions?.loading) {
        setModalVisible(false);
        setModalOptions(null);
      }
    };
    $[10] = modalOptions?.loading;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleModalClose = t9;
  let t10;
  if ($[12] !== setAlertLoading || $[13] !== setButtonLoading) {
    t10 = {
      showAlert,
      showSuccessAlert,
      showErrorAlert,
      showConfirmAlert,
      showLoadingAlert,
      hideAlert,
      setAlertLoading,
      setButtonLoading
    };
    $[12] = setAlertLoading;
    $[13] = setButtonLoading;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const contextValue = t10;
  let t11;
  if ($[15] !== handleModalClose || $[16] !== modalOptions || $[17] !== modalVisible) {
    t11 = modalOptions && <ModalAlert visible={modalVisible} title={modalOptions.title} message={modalOptions.message} buttons={modalOptions.buttons} loading={modalOptions.loading} onClose={handleModalClose} />;
    $[15] = handleModalClose;
    $[16] = modalOptions;
    $[17] = modalVisible;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== children || $[20] !== contextValue || $[21] !== t11) {
    t12 = <AlertContext.Provider value={contextValue}>{children}{t11}</AlertContext.Provider>;
    $[19] = children;
    $[20] = contextValue;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};